export default __webpack_public_path__ + "static/media/working-with-us-image.62e504f8.jpg";